<div class="container">
  <div *ngIf="loadProducts" id="loadingPage"></div>
  <div class="row fam" *ngIf="!loadProducts">
    <div class="col-xs-6 fam-c" *ngFor="let product of products;let i=index">
      <product  [product]="product"></product>
    </div>
  </div>
</div>